import React from 'react'
import ZeroPercentFinance from '../components/Sections/Finance'

function FinancePage() {
  return (
    <div>
      <ZeroPercentFinance/>
    </div>
  )
}

export default FinancePage